import { useEffect, useState } from "react";

// Same localStorage keys as the original QKart app, so existing logins carry over.
const KEYS = ["token", "username", "balance"];
const listeners = new Set();

const read = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};
const write = (key, value) => {
  try {
    if (value === null || value === undefined) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, String(value));
  } catch (e) {
    // Storage unavailable (e.g. private mode): the session lasts until reload.
  }
};

let memory = null;
const snapshot = () => {
  if (memory) return memory;
  const token = read("token");
  return {
    token,
    username: read("username"),
    balance: Number(read("balance")) || 0,
    loggedIn: Boolean(token),
  };
};

const emit = () => listeners.forEach((fn) => fn(getSession()));

export const getSession = () => snapshot();

export const saveSession = ({ token, username, balance }) => {
  write("token", token);
  write("username", username);
  write("balance", balance);
  memory = { token, username, balance: Number(balance) || 0, loggedIn: Boolean(token) };
  emit();
};

export const setBalance = (balance) => {
  write("balance", balance);
  memory = { ...snapshot(), balance: Number(balance) || 0 };
  emit();
};

export const clearSession = () => {
  KEYS.forEach((key) => write(key, null));
  memory = { token: null, username: null, balance: 0, loggedIn: false };
  emit();
};

export const useSession = () => {
  const [session, setSession] = useState(getSession);
  useEffect(() => {
    listeners.add(setSession);
    return () => listeners.delete(setSession);
  }, []);
  return session;
};
